import { Check } from 'lucide-react';
import { cn } from '../../../utils/utils';

interface StepIndicatorProps {
  step: number;
  currentStep: number;
  label: string;
  className?: string;
}

export function StepIndicator({ step, currentStep, label, className }: StepIndicatorProps) {
  const isActive = step === currentStep;
  const isCompleted = step < currentStep;

  return (
    <div className={cn("flex flex-col items-center z-10", className)}>
      <div
        className={cn(
          "flex items-center justify-center w-10 h-10 rounded-full mb-2 transition-colors",
          isActive && "bg-primary-600 text-white border-2 border-primary-600",
          isCompleted && "bg-primary-400 text-white",
          !isActive && !isCompleted && "bg-white text-gray-500 border-2 border-gray-300"
        )}
      >
        {isCompleted ? (
          <Check className="w-5 h-5" />
        ) : (
          <span className="font-medium">{step}</span>
        )}
      </div>
      <span
        className={cn(
          "text-sm",
          isActive && "text-primary-600 font-medium",
          isCompleted && "text-primary-400",
          !isActive && !isCompleted && "text-gray-500"
        )}
      >
        {label}
      </span>
    </div>
  );
}